import { Col, Row, Image } from 'react-bootstrap'
import Link from 'next/link'

const data =[
    {title:"Welcome from our Experts", image:"https://via.placeholder.com/450x250", url:"/home"},
    {title:"Quick Orientation", image:"https://via.placeholder.com/450x250", url:"/home"},
    {title:"Popular Products", image:"https://via.placeholder.com/450x250", url:"/home"}
]

function ThreeVid() {
    return (
        <Row className="my-5 mx-lg-5 px-lg-5 py-3">
            {data.map((data,idx) => (
                <Col md={4} key={idx} className="text-center h7 mb-5">
                    <p className="h6 mb-3">{data.title}</p>
                    <Image src={data.image} className="img-fluid mb-4"/>
                    <Link href={data.url}><a className="border-green border text-decoration-none text-reset px-4 py-1 d-inline-block btn-trans-green">Watch</a></Link>
                </Col>
            ))}
        </Row>
    )
}

export default ThreeVid
